export default __webpack_public_path__ + "static/media/042-tuxedo.29957088.svg";